import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/app-dir/link.js");
